module.exports = __webpack_public_path__ + "img/countdownStop.b7f8bcbf.svg";